export default async function ({ store, redirect, route }) {
  // eslint-disable-next-line
  console.log('isQuoteEmpty public mid', store.getters['quote/isQuoteEmpty'])

  if (store.getters['quote/isQuoteEmpty']) {
    await store.dispatch(
      'quote/fetchPublicQuote',
      route.params.quoteid || route.params.policyid
    )
    if (store.getters['quote/quoteError']) {
      return redirect('/')
    } else {
      await store.dispatch('quote/calculatePrice')
    }
  }
}
